import { Component, EventEmitter, Inject, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ApplicationFacade, Departure, Stop, TripClickEvent } from '@ridango/components';
import Env from '@ridango/core/env';
import { Temporal } from '@js-temporal/polyfill';
import { AppStartupService, DisruptionMessage } from '@ridango/core';

@Component({
    selector: 'rwidget-bus-stop-short',
    templateUrl: './bus-stop-short.component.html',
    styleUrls: ['./bus-stop-short.component.scss']
})
export class BusStopShortComponent implements OnChanges {
    @Input() stop: Stop;
    @Input() departures: Departure[] = [];
    @Input() showNumberOfTimes = 3;
    @Output() showAllClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() tripClick: EventEmitter<TripClickEvent> = new EventEmitter<TripClickEvent>();
    @Input() isLoadingDepartures;

    assetsPath$ = this.applicationFacade.assetsPath$;
    disruptionMessages: DisruptionMessage[] = [];
    timezone = this.appStartupService.getTimezone();

    constructor(
        @Inject('ENV') private env: Env,
        private appStartupService: AppStartupService,
        private applicationFacade: ApplicationFacade
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['stop']) {
            const messages = this.stop?.disruptionMessages ?? [];
            const now = Temporal.Now.instant().toZonedDateTimeISO(this.timezone);
            this.disruptionMessages = messages.filter((m: DisruptionMessage) => {
                try {
                    const start = Temporal.Instant.from(m.activePeriodStart.toString()).toZonedDateTimeISO(
                        this.timezone
                    );
                    const end = Temporal.Instant.from(m.activePeriodEnd.toString()).toZonedDateTimeISO(this.timezone);
                    return (
                        start.epochNanoseconds <= now.epochNanoseconds && now.epochNanoseconds <= end.epochNanoseconds
                    );
                } catch {
                    return false;
                }
            });
        }
    }

    getDeparturePatch(): Departure[] {
        const loadedDepartures = this.departures ?? [];
        return this.env.EXPLORE?.DEPARTURES_REQUEST_MAX_NO_PATCHING
            ? loadedDepartures
            : loadedDepartures.slice(0, this.showNumberOfTimes);
    }

    emitDepartureClick(departure: Departure) {
        this.tripClick.emit({
            tripId: departure.time.tripId,
            userDepartStopId: this.stop.id,
            routeId: departure.route.id,
            shortName: this.env.EXPLORE?.SELECTED_BUS_STOPPED ? departure.route.shortName : null
        });
    }
}
